/*
  acualux.js — comportamento da identidade Acualux.
  Substitui o motion/react do front Next.js por IntersectionObserver + CSS.
  Vanilla, sem dependencia, degrada sem JS (ver .no-js no CSS do reveal).
*/
(function () {
  'use strict';

  /* --- reveal on scroll --- */
  function initReveal(root) {
    var alvos = (root || document).querySelectorAll('.acx-reveal:not([data-acx-bound])');
    if (!alvos.length) return;

    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        // delay escalonado, como o `delay` do <Reveal> no React
        var i = Number(e.target.getAttribute('data-acx-delay') || 0);
        e.target.style.transitionDelay = (i * 90) + 'ms';
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    alvos.forEach(function (el) {
      el.setAttribute('data-acx-bound', '1');
      io.observe(el);
    });
  }

  /* --- header: transparente sobre o hero, solido apos rolar --- */
  function initHeader() {
    var header = document.querySelector('.acx-header');
    if (!header) return;

    // O servidor ja decidiu se ha hero (data-tem-hero); o seletor e so o reforco.
    var temHero = header.getAttribute('data-tem-hero') === 'true'
      || document.querySelector('.acx-hero') !== null;
    var burger = header.querySelector('.acx-burger');
    var logo = header.querySelector('.acx-header__logo-img');

    function aoRolar() {
      var rolou = window.scrollY > 40;
      var aberto = header.classList.contains('is-open');
      var solido = rolou || aberto || !temHero;

      header.classList.toggle('is-solid', solido);

      // Um unico <img>: troca o src em vez de alternar dois elementos.
      if (logo) {
        var alvo = solido
          ? logo.getAttribute('data-logo-escuro')
          : logo.getAttribute('data-logo-claro');
        if (alvo && logo.getAttribute('src') !== alvo) logo.setAttribute('src', alvo);
      }
    }

    if (burger) {
      burger.addEventListener('click', function () {
        header.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', header.classList.contains('is-open') ? 'true' : 'false');
        aoRolar();
      });
      header.querySelectorAll('.acx-mobile-menu a').forEach(function (a) {
        a.addEventListener('click', function () {
          header.classList.remove('is-open');
          aoRolar();
        });
      });
    }

    aoRolar();
    window.addEventListener('scroll', aoRolar, { passive: true });
  }

  /* --- slideshow do bloco Impacto --- */
  function initSlideshow() {
    document.querySelectorAll('.acx-slideshow').forEach(function (box) {
      var slides = box.querySelectorAll('img');
      if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }

      var i = 0;
      slides[0].classList.add('is-active');
      var intervalo = Number(box.getAttribute('data-intervalo') || 4000);

      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, intervalo);
    });
  }

  /* --- mega menu: fecha com atraso --- */
  function initMega() {
    document.querySelectorAll('.acx-nav__item--tem-menu:not([data-acx-mega])').forEach(function (item) {
      item.setAttribute('data-acx-mega', '1');

      var timer = null;
      var ATRASO = 260; // ms de tolerancia entre sair do item e entrar no painel

      function abrir() {
        clearTimeout(timer);
        item.classList.add('is-aberto');
      }
      function fecharDepois() {
        clearTimeout(timer);
        timer = setTimeout(function () { item.classList.remove('is-aberto'); }, ATRASO);
      }

      item.addEventListener('mouseenter', abrir);
      item.addEventListener('mouseleave', fecharDepois);
      item.addEventListener('focusin', abrir);
      item.addEventListener('focusout', fecharDepois);

      // Esc fecha na hora
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { clearTimeout(timer); item.classList.remove('is-aberto'); }
      });

      // clicar numa linha fecha sem esperar
      item.querySelectorAll('.acx-mega__item').forEach(function (a) {
        a.addEventListener('click', function () {
          clearTimeout(timer);
          item.classList.remove('is-aberto');
        });
      });
    });
  }

  /* --- galeria da pagina de produto --- */
  function initGaleria() {
    var galeria = document.querySelector('.acx-galeria:not([data-acx-pronta])');
    if (!galeria) return;
    galeria.setAttribute('data-acx-pronta', '1');

    var palco = galeria.querySelector('[data-acx-palco]');
    var fotos = galeria.querySelectorAll('.acx-galeria__foto');
    var minis = galeria.querySelectorAll('.acx-galeria__mini');

    function mostrar(idMedia) {
      fotos.forEach(function (f) {
        f.classList.toggle('is-ativa', f.getAttribute('data-media-id') === idMedia);
      });
      // a miniatura da foto em exibicao sai de cena; sobram as outras
      minis.forEach(function (m) {
        m.classList.toggle('is-oculta', m.getAttribute('data-alvo') === idMedia);
      });
    }

    minis.forEach(function (m) {
      m.addEventListener('click', function () { mostrar(m.getAttribute('data-alvo')); });
    });

    /* zoom no hover: origem do transform acompanha o cursor.
       Antes de ampliar, troca o arquivo pelo de 2400px — o transform estica o
       bitmap que estiver carregado, entao ampliar 2.2x uma imagem de 1440
       exibida a ~1050px daria borrado. A troca acontece uma vez; depois o
       navegador serve do cache. */
    function carregarAlta(img) {
      var alta = img.getAttribute('data-zoom');
      if (!alta || img.getAttribute('data-alta-ok')) return;
      img.setAttribute('data-alta-ok', '1');
      var pre = new Image();
      pre.onload = function () { img.src = alta; img.removeAttribute('srcset'); };
      pre.src = alta;
    }

    if (palco && window.matchMedia('(hover: hover)').matches) {
      palco.addEventListener('mouseenter', function () {
        var ativa = galeria.querySelector('.acx-galeria__foto.is-ativa');
        if (ativa && ativa.tagName === 'IMG') carregarAlta(ativa);
        palco.classList.add('is-ampliando');
      });
      palco.addEventListener('mouseleave', function () {
        palco.classList.remove('is-ampliando');
        fotos.forEach(function (f) { f.style.transformOrigin = 'center center'; });
      });
      palco.addEventListener('mousemove', function (e) {
        var ativa = galeria.querySelector('.acx-galeria__foto.is-ativa');
        if (!ativa || !ativa.naturalWidth) return;

        /* `transform-origin` em % se refere a CAIXA do elemento, mas com
           object-fit: contain a imagem pintada e menor que a caixa quando a
           foto nao e 2:3 — ha tarja. Usar a % da caixa apontava para o lugar
           errado, com erro crescente longe do centro (medido: 40px numa foto
           3:4). Aqui a % e convertida para dentro da area realmente pintada. */
        var r = palco.getBoundingClientRect();
        var escala = Math.min(r.width / ativa.naturalWidth, r.height / ativa.naturalHeight);
        var pintW = ativa.naturalWidth * escala;
        var pintH = ativa.naturalHeight * escala;
        var tarjaX = (r.width - pintW) / 2;
        var tarjaY = (r.height - pintH) / 2;

        var x = ((e.clientX - r.left - tarjaX) / pintW) * 100;
        var y = ((e.clientY - r.top - tarjaY) / pintH) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));

        // em px sobre a caixa, para o navegador nao reinterpretar a %
        ativa.style.transformOrigin = (tarjaX + pintW * x / 100) + 'px ' +
                                      (tarjaY + pintH * y / 100) + 'px';
      });
    }

    /* Lightbox so onde nao ha hover.
       No PC o cliente quer apenas o cursor ampliando, sem abrir nada ao
       clicar. No toque nao existe hover, entao sem o lightbox nao sobraria
       nenhuma forma de ver o detalhe — la ele fica. */
    if (window.matchMedia('(hover: hover)').matches) {
      var lupaPc = galeria.querySelector('[data-acx-ampliar]');
      if (lupaPc) lupaPc.remove();
      return;
    }

    var caixa = document.querySelector('.acx-lightbox');
    if (!caixa) {
      caixa = document.createElement('div');
      caixa.className = 'acx-lightbox';
      caixa.innerHTML = '<button type="button" class="acx-lightbox__fechar" aria-label="Fechar">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button><img alt=""><span class="acx-lightbox__dica">Clique para ampliar</span>';
      document.body.appendChild(caixa);
    }
    var imgCaixa = caixa.querySelector('img');

    function abrir() {
      var ativa = galeria.querySelector('.acx-galeria__foto.is-ativa');
      if (!ativa || !ativa.getAttribute) return;
      // 3200px: o lightbox limita a altura da tela, entao numa foto 2:3 a
      // largura fica pequena. Com essa resolucao sobra detalhe para ampliar.
      imgCaixa.src = ativa.getAttribute('data-cheia') || ativa.getAttribute('data-zoom') || ativa.src;
      imgCaixa.alt = ativa.alt || '';
      caixa.classList.remove('is-ampliado');
      imgCaixa.style.transform = '';
      caixa.classList.add('is-aberto');
      document.body.style.overflow = 'hidden';
    }
    function fechar() {
      caixa.classList.remove('is-aberto', 'is-ampliado');
      imgCaixa.style.transform = '';
      document.body.style.overflow = '';
    }

    /* Dentro do lightbox: clique amplia, e o mouse desloca a area visivel.
       Sem isso a foto abria "pequena" — limitada pela altura da janela — e
       nao havia como chegar perto do detalhe. */
    var ESCALA = 2.6;
    function posicionar(e) {
      if (!caixa.classList.contains('is-ampliado')) return;
      var r = imgCaixa.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      var dx = (0.5 - px) * r.width * (ESCALA - 1);
      var dy = (0.5 - py) * r.height * (ESCALA - 1);
      imgCaixa.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + ESCALA + ')';
    }
    imgCaixa.addEventListener('click', function (e) {
      e.stopPropagation();
      var ampliado = caixa.classList.toggle('is-ampliado');
      if (ampliado) posicionar(e);
      else imgCaixa.style.transform = '';
    });
    imgCaixa.addEventListener('mousemove', posicionar);

    var botaoLupa = galeria.querySelector('[data-acx-ampliar]');
    if (botaoLupa) botaoLupa.addEventListener('click', function (e) { e.stopPropagation(); abrir(); });
    if (palco) palco.addEventListener('click', abrir);

    caixa.addEventListener('click', fechar);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && caixa.classList.contains('is-aberto')) fechar();
    });
  }

  function init() { initReveal(); initHeader(); initSlideshow(); initMega(); initGaleria(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // o editor de temas recarrega secoes sem recarregar a pagina
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initHeader(); initSlideshow(); initMega(); initGaleria();
  });
})();
